export default __webpack_public_path__ + "simple-arrow-down.svg";